/**
 * 比较版本号
 * @param ver1
 * @param ver2
 */
export function compareVersion(ver1: string, ver2: string) {
  if (typeof ver1 !== 'string') {
    throw new Error(`version1 should be type of string: ${ver1}`);
  }
  if (typeof ver2 !== 'string') {
    throw new Error(`version2 should be type of string: ${ver2}`);
  }

  const v1 = ver1.split('.');
  const v2 = ver2.split('.');
  const len1 = v1.length;
  const len2 = v2.length;
  for (let i = 0; i < len1 && i < len2; i++) {
    const num1 = parseInt(v1[i], 10);
    if (isNaN(num1) || num1 < 0) {
      throw new Error(`invalid version1: ${v1}`);
    }
    const num2 = parseInt(v2[i], 10);
    if (isNaN(num2) || num2 < 0) {
      throw new Error(`invalid version2: ${v2}`);
    }
    if (num1 < num2) {
      return -1;
    }
    if (num1 > num2) {
      return 1;
    }
  }

  if (len1 === len2) {
    return 0;
  }

  if (len1 > len2) {
    for (let i = len2; i < len1; i++) {
      if (v1[i] !== '0') {
        return 1;
      }
    }
    return 0;
  }
  for (let i = len1; i < len2; i++) {
    if (v2[i] !== '0') {
      return -1;
    }
  }
  return 0;
}
